// export const SERVER_URL = 'https://flyinn-backend-i8oh5.kinsta.app';
// export const SERVER_URL = `https://flyinn-backend-development-g6l85.kinsta.app`;
// export const SERVER_URL = `http://100.28.174.189:8000`;
export const SERVER_URL = process.env.REACT_APP_LARAVEL_SERVER_URL;
export const PROFILE_IMAGE_SERVER_URL =
  process.env.REACT_APP_PROFILE_IMAGE_SERVER_URL;
// export const SERVER_URL = `http://127.0.0.1:8000`;

// export const NODE_SERVER_URL = `https://flyinn-backend-development-g6l85.kinsta.app`;
// export const NODE_SERVER_URL = process.env.NODE_SERVER_URL || `https://airmailserver-fz4sb.kinsta.app`;
// export const NODE_SERVER_URL = 'http://localhost:5001';
export const NODE_SERVER_URL = process.env.REACT_APP_NODE_SERVER_URI || "";
// export const NODE_SERVER_URL = 'http://api.fly-inn.com:5001';

export const SERVER_IMAGES_URL = process.env.REACT_APP_SERVER_IMAGES_URL || "";

export const renderImage = (image) => {
  if (typeof image === "string") {
    // This is for existing images from the API
    if (image.includes("https://s3.")) {
      return image;
    }
  } else if (image instanceof File) {
    // This is for newly uploaded images
    return URL.createObjectURL(image);
  }
  // Fallback for other cases
  return image;
};

export const ADD_LISTING_DEFAULT_VALUES = {
  is_draft: 0,
  host_id: "",
  listing_type: "",
  address: "",
  apt_suite: "",
  city: "",
  state: "",
  zipcode: "",
  area: "",
  country: "",
  latitude: 0,
  longitude: 0,
  images: [],
  title: "",
  type_of_space: "",
  lodging_type: "",
  no_of_bedrooms: 0,
  no_of_guest: 1,
  imgdescription: [],
  no_of_beds: 0,
  no_of_bathrooms: 1,
  no_of_rooms: 0,
  size: 1,
  unit_of_measure: "ft",
  description: "",
  bedrooms: [],
  airports: [
    {
      airport_identifier: "",
      airport_name: "",
      airport_use: "",
      ctaf_unicom: "",
      dimension_feets: "",
      dimension_meters: "",
      elevation_feets: 0,
      elevation_meters: 0,
      fuel: [],
      lighting: 0,
      operation_hours: "",
      orientation: "",
      runway_condition: "",
      parking: "",
      pattern: "",
      surface: [],
      condition: "",
      air_nav: "",
      ground_transportation: "",
      distance_from_runway: -1,
      additional_info: "",
    },
  ],
  instant_booking: 0,
  nightly_price: 0,
  apply_weekend_price: "None",
  weekend_nightly_price: 0,
  night_price_seven_plus: 0,
  night_price_thirty_plus: 0,
  additional_guest: 0,
  no_of_additional_guest: 0,
  additional_guest_price: 0,
  pet_allowed: 0,
  no_of_pets: 0,
  price_per_pet: 0,
  cleaning_fee: 0,
  cleaning_freq: "",
  city_fee: 0,
  city_fee_freq: "",
  tax_percentage: 0,
  custom_period_pricing: 0,
  custom_periods: [],
  extra_services: 0,
  extra_service: [],
  features: [
    // {
    //     id: '',
    //     feature_id: "",
    //     sub_features: []
    // }
  ],
  helicopter_allowed: 0,
  cancellation_policy_short: "",
  cancellation_policy_long: "",
  min_day_booking: 1,
  max_day_booking: 2,
  check_in_after: "",
  check_out_before: "",
  smoking_allowed: 0,
  smoking_rules: "",
  rules_pet_allowed: 0,
  pet_rules: "",
  party_allowed: 0,
  party_rules: "",
  children_allowed: 0,
  // children_rules: '',
  // infant_start_age: '',
  // infant_end_age: '',
  // child_start_age: '',
  // child_end_age: '',
  rules: "",
  welcome_message: "",
  blocked_dates: [],
  priority: 200,
};

export const SAMPLE_LISTING_DATA = {
  is_draft: "1",
  host_id: "371",
  listing_type: "Short-Term Rental",
  address: "6 Quimby Ln, East Falmouth, MA 02536, USA",
  city: "Falmouth",
  state: "MA",
  zipcode: "02536",
  area: "6 Quimby Lane",
  country: "United States",
  latitude: "41.585758",
  longitude: "-70.541466",
  title: "(5B6) Falmouth Airpark - Cape Cod Home On The Runway",
  type_of_space: "Entire Place",
  lodging_type: "Hangar Home",
  no_of_bedrooms: "3",
  no_of_guest: "6",
  no_of_beds: "3",
  no_of_bathrooms: "2.5",
  no_of_rooms: "7",
  size: "3200",
  unit_of_measure: "ft",
  description: `<p><strong>Stunning, Nearly New Cape Cod Home with Private Runway Access!</strong></p>
                  <p>This gorgeous Cape Cod home is a true aviation enthusiast's dream! Located directly on the runway, this property offers unparalleled convenience—park your plane just steps from your back door. Featuring high-end appliances, including SubZero and Wolf, this home combines luxury and practicality.</p>
                  <p>Inside, you'll find soaring 10-foot ceilings, beautiful windows that fill the space with natural light, and a huge slider that leads to your backyard, where the views are absolutely breathtaking. As a bonus, a charming biplane weather vane adds a unique touch of character to the home.</p>
                  <p>The beach is just a mile away by air and 2 miles by car, so you can enjoy the Cape Cod lifestyle with ease. Plus, with Nantucket and Martha's Vineyard only an 8-minute flight away, you'll have endless adventures at your fingertips.</p>
                  <p>This home is truly a one-of-a-kind find, offering the best of Cape Cod living with a private aviation twist!</p>`,
  airports: [
    {
      airport_identifier: "5B6",
      airport_name: "Falmouth",
      airport_use: "Public",
      ctaf_unicom: "123.075",
      dimension_feets: "2298X40",
      dimension_meters: "700X12",
      elevation_feets: "38",
      elevation_meters: "41",
      fuel: ["100LL", "other"],
      lighting: "1",
      operation_hours: "0800 - 1600",
      orientation: "07/25",
      runway_condition: "Good",
      parking: "Tie-downs",
      pattern: "right, left",
      surface: ["Asphalt", "Grass"],
      air_nav: "https://airnav.com/airport/5B6",
      ground_transportation: "We have a vehicle you can rent from us!",
      distance_from_runway: "0",
      additional_info: "2015 Chevy Silverado. Beach sticker. $50 a day.",
    },
  ],
  instant_booking: "0",
  nightly_price: "395",
  apply_weekend_price: "None",
  weekend_nightly_price: "0",
  night_price_seven_plus: "0",
  night_price_thirty_plus: "0",
  additional_guest: "0",
  no_of_additional_guest: "0",
  additional_guest_price: "0",
  pet_allowed: "0",
  no_of_pets: "0",
  price_per_pet: "0",
  cleaning_fee: "225",
  cleaning_freq: "Per stay",
  city_fee: "0",
  tax_percentage: "7",
  custom_period_pricing: "0",
  extra_services: "0",
  features: [
    {
      id: "21",
      sub_features: [
        "767",
        "770",
        "771",
        "781",
        "784",
        "785",
        "786",
        "788",
        "787",
        "791",
        "794",
        "793",
        "797",
        "796",
        "795",
      ],
    },
    {
      id: "20",
      sub_features: [
        "735",
        "736",
        "737",
        "738",
        "740",
        "741",
        "742",
        "744",
        "748",
        "749",
      ],
    },
    {
      id: "19",
      sub_features: ["727", "733"],
    },
    {
      id: "18",
      sub_features: ["716", "718"],
    },
    {
      id: "17",
      sub_features: ["676", "677", "682", "689"],
    },
    {
      id: "15",
      sub_features: ["666"],
    },
    {
      id: "8",
      sub_features: [
        "110",
        "74",
        "76",
        "77",
        "78",
        "79",
        "80",
        "81",
        "82",
        "83",
        "84",
        "86",
        "87",
        "89",
        "90",
        "91",
        "93",
        "100",
        "99",
        "96",
        "97",
        "103",
        "106",
        "105",
        "109",
      ],
    },
    {
      id: "7",
      sub_features: ["73", "72"],
    },
    {
      id: "6",
      sub_features: ["60", "61", "62", "63", "67", "66", "71"],
    },
  ],
  cancellation_policy_short: "3",
  cancellation_policy_long: "7",
  min_day_booking: "1",
  max_day_booking: "27",
  check_in_after: "03:00 PM",
  check_out_before: "10:00 AM",
  smoking_allowed: "0",
  rules_pet_allowed: "0",
  party_allowed: "0",
  children_allowed: "1",
  rules:
    "Report Any Damages: Please report any accidental damages immediately. Any unreported damages may result in fees.",
  welcome_message:
    "<p>Thank you for choosing to stay with us! We hope you have a fantastic visit. Feel free to reach out with any questions or concerns.</p>",
  priority: "200",
  helicopter_allowed: "1",
  infant_start_age: "0",
  infant_end_age: "10",
  child_start_age: "12",
  child_end_age: "17",
};

export const PROFILE_FORM_DEFAULT_VALUES = {
  // Personal Information
  first_name: "",
  last_name: "",
  username: "",
  display_name: "",
  native_language: "",
  other_language: "",
  phone: "",
  other_phone: "",
  email: "",
  bio: "",

  // Documents
  air_men: null,
  air_men_back: null,
  driving_license: null,
  driving_license_back: null,

  // Address Information
  address: "",
  city: "",
  state: "",
  zip_code: "",
  country: "",
  same_as_mailing: false,

  // Emergency Contact
  contact_name: "",
  contact_relationship: "",
  contact_email: "",
  contact_phone: "",

  // Social Media URLs
  facebook_url: "",
  instagram_url: "",
  airbnb_url: "",
  vrbo_url: "",
  youtube_url: "",
  twitter_url: "",
  linkedin_url: "",
  pinterest_url: "",
  vimeo_url: "",
  top_advisor_url: "",

  // Image Upload
  image: null,
};

export const SEARCH_MAP_DEFAULT_VALUES = {
  destination: "",
  arrival_date: null,
  departure_date: null,
  no_of_guest: "",
  no_of_rooms: "",
  no_of_bedrooms: "",
  lodging_type: "",
  type_of_space: "",
  closest_runway: "",
  price_min: "",
  price_max: "",
  features: [],
  sub_features: [],
};

// Reserved words array for username validation
export const RESERVED_WORDS = [
  "admin",
  "support",
  "moderator",
  "owner",
  "root",
  "superuser",
  "alphahost",
  "administrator",
  "user",
  "guest",
  "developer",
  "webmaster",
  "manager",
  "api",
  "login",
  "logout",
  "system",
  "bot",
  "server",
  "adminpanel",
  "database",
  "dashboard",
  "backend",
  "frontend",
  "secure",
  "security",
  "password",
  "ssl",
  "privacy",
  "encryption",
  "www",
  "http",
  "https",
  "html",
  "ftp",
  "smtp",
  "FlyInn",
  "Fly-Inn",
  "test",
  "sample",
  "placeholder",
  "example",
  "demo",
  "support",
  "team",
  "helpdesk",
  "customerservice",
  "terms",
  "policy",
  "legal",
  "privacy",
  "contactus",
  "billing",
  "payment",
  "online",
  "offline",
  "active",
  "inactive",
  "banned",
  "verified",
  "chat",
  "inbox",
  "notification",
  "message",
  "messenger",
];

export const RESTRICTED_DOMAINS = [
  "mailinator.com",
  "tempmail.com",
  "trashmail.com",
  "10minutemail.com",
  "guerrillamail.com",
  "maildrop.cc",
  "yopmail.com",
  "throwawaymail.com",
  "getnada.com",
  "temp-mail.org",
  "dispostable.com",
  "fakeinbox.com",
  "emailondeck.com",
  "mohmal.com",
  "spamgourmet.com",
  "burnermail.io",
  "spambog.com",
  "discard.email",
  "sharklasers.com",
  "mintemail.com",
  "mytemp.email",
  "fakemail.net",
  "anonbox.net",
  "jetable.org",
  "wegwerfemail.de",
  "mailcatch.com",
  "emlpro.com",
  "owlymail.com",
  "tempmailo.com",
  "easytrashmail.com",
  "e4ward.com",
  "spam4.me",
  "eyepaste.com",
  "boun.cr",
  "opayq.com",
  "fastmailbox.net",
  "tempail.com",
  "mail.tm",
  "mailnesia.com",
  "altmails.com",
  "inboxkitten.com",
  "trashmail.de",
  "hushmail.com",
  "vip-mail.net",
  "mailsac.com",
  "moakt.com",
  "luxusmail.org",
  "cyberfear.com",
  "relay.firefox.com",
  "24hourmail.com",
  "shortmail.net",
];

export const LODGING_TYPES = [
  "Apt. / Condo / Loft",
  "Bed & Breakfast",
  "Cabin",
  "House",
  "Campsite",
  "Farm",
  "Hangar",
  "Hangar Home",
  "Mansion",
  "Novelty",
  "RV",
  "RV Pad",
  "Tiny Home",
];

export const LODGING_TYPES_DROPDOWN = [
  {
    text: "Apartment",
    name: "Apt. / Condo / Loft",
    type: "lodging_type",
    link: `lodging_type/${encodeURIComponent("Apt. / Condo / Loft")}`,
    image: "images/all/homedwelling11.webp",
  },
  {
    name: "Bed & Breakfast",
    type: "lodging_type",
    link: `lodging_type/${encodeURIComponent("Bed & Breakfast")}`,
    image: "images/all/homedwelling2.webp",
  },
  {
    name: "Beachfront",
    type: "lodging_type",
    link: `lodging_type/${encodeURIComponent("Beachfront")}`,
    image: "images/all/homedwelling2b.webp",
  },
  {
    name: "Cabin",
    type: "lodging_type",
    link: `lodging_type/${encodeURIComponent("Cabin")}`,
    image: "images/all/homedwelling3.webp",
  },
  {
    name: "Campsite",
    type: "lodging_type",
    link: `lodging_type/${encodeURIComponent("Campsite")}`,
    image: "images/all/homedwelling4.webp",
  },
  {
    name: "Farm",
    type: "lodging_type",
    link: `lodging_type/${encodeURIComponent("Farm")}`,
    image: "images/all/homedwelling6.webp",
  },
  {
    name: "Hangar",
    type: "lodging_type",
    link: `lodging_type/${encodeURIComponent("Hangar")}`,
    image: "images/all/homedwelling7.webp",
  },
  {
    name: "Hangar Home",
    type: "lodging_type",
    link: `lodging_type/${encodeURIComponent("Hangar Home")}`,
    image: "images/all/homedwelling8.webp",
  },
  {
    name: "House",
    type: "lodging_type",
    link: `lodging_type/${encodeURIComponent("House")}`,
    image: "images/all/homedwelling9.webp",
  },
  {
    name: "Hotel Room",
    type: "lodging_type",
    link: `lodging_type/hotel_room`,
    image: "images/all/homedwelling14.webp",
  },
  {
    name: "Mansion",
    type: "lodging_type",
    link: `lodging_type/${encodeURIComponent("Mansion")}`,
    image: "images/all/homedwelling12.webp",
  },
  {
    name: "Novelty",
    type: "lodging_type",
    link: `lodging_type/${encodeURIComponent("Novelty")}`,
    image: "images/all/homedwelling14.webp",
  },
  {
    name: "RV",
    type: "lodging_type",
    link: `lodging_type/${encodeURIComponent("RV")}`,
    image: "images/all/rv.png",
  },
  {
    name: "RV Pad",
    type: "lodging_type",
    link: `lodging_type/${encodeURIComponent("RV Pad")}`,
    image: "images/all/rvpad.png",
  },
  {
    name: "Tiny Home",
    type: "lodging_type",
    link: `lodging_type/${encodeURIComponent("Tiny Home")}`,
    image: "images/all/homedwelling14.webp",
  },
];

export const SPACE_TYPES_DROPDOWN = [
  {
    name: "Entire Place",
    type: "type_of_space",
    link: "type_of_space/Entire_Place",
  },
  {
    name: "Private Room",
    type: "type_of_space",
    link: "type_of_space/Private_Room",
  },
  {
    name: "Shared Room",
    type: "type_of_space",
    link: "type_of_space/Shared_Room",
  },
];

export const SNAZZY_MAP_STYLES = [
  {
    featureType: "all",
    elementType: "labels.text.fill",
    stylers: [
      {
        saturation: 36,
      },
      {
        color: "#333333",
      },
      {
        lightness: 40,
      },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.text.stroke",
    stylers: [
      {
        visibility: "on",
      },
      {
        color: "#ffffff",
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#000000",
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#000000",
      },
      {
        lightness: 80,
      },
      {
        weight: 1.2,
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [
      {
        color: "#edebe4",
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        color: "#f5f5f5",
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: "#dedede",
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#d1ecc7",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#ffffff",
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#ffffff",
      },
      {
        lightness: 29,
      },
      {
        weight: 0.2,
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      {
        color: "#ffffff",
      },
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [
      {
        color: "#ffffff",
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [
      {
        color: "#f2f2f2",
      },
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#bddddd",
      },
      {
        lightness: 17,
      },
    ],
  },
];

export const BUSINESS_TYPES = [
  { type: "restaurants", icon: "fa fa-utensils", label: "Restaurants" },
  { type: "events", icon: "fa fa-calendar", label: "Events" },
  { type: "shopping", icon: "fa fa-shopping-cart", label: "Shopping" },
  { type: "adventures", icon: "fa fa-hiking", label: "Adventures" },
  { type: "hotels", icon: "fa fa-hotel", label: "Hotels" },
  { type: "flight_schools", icon: "fa fa-plane", label: "Flight Schools" },
  { type: "cfis", icon: "fa fa-plane", label: "CFIs" },
  {
    type: "aircraft_sales_rentals",
    icon: "fa fa-plane-departure",
    label: "Aircraft Sales / Rentals",
  },
  {
    type: "aircraft_services_parts",
    icon: "fa fa-cogs",
    label: "Aircraft Services / Parts",
  },
  {
    type: "medical_examiners",
    icon: "fa fa-user-md",
    label: "Medical Examiners",
  },
  { type: "insurance", icon: "fa fa-shield-alt", label: "Insurance" }, // Added Insurance
];

export const BUSINESS_SUBTYPES = [
  {
    category: "Aircraft Brokers & Dealers",
    subcategories: [
      {
        type: "aircraft_sales_new",
        label: "Aircraft Sales - New",
        icon: "fa fa-plane",
        description:
          "Factory-direct or authorized dealers offering the latest models across categories.",
      },
      {
        type: "aircraft_sales_pre_owned",
        label: "Aircraft Sales - Pre-Owned",
        icon: "fa fa-plane",
        description:
          "Experts who connect buyers and sellers of used aircraft, from singles to jets.",
      },
      {
        type: "leasing_fractional_ownership",
        label: "Leasing & Fractional Ownership",
        icon: "fa fa-plane",
        description:
          "Flexible ownership models including dry leases, wet leases, and shared access.",
      },
      {
        type: "commercial_aircraft_brokers_dealers",
        label: "Commerical Aircraft Brokers & Dealers",
        icon: "fa fa-plane",
        description:
          "Firms handling large passenger, cargo, or utility aircraft transactions for airlines or fleets.",
      },
      {
        type: "corporate_jet_brokers_dealers",
        label: "Corporate Jet Brokers & Dealers",
        icon: "fa fa-plane",
        description:
          "Specialists in sourcing, listing, or managing sales of midsize to heavy business jets.",
      },
      {
        type: "helicopter_brokers_dealers",
        label: "Helicopter Brokers & Dealers",
        icon: "fa fa-helicopter",
        description:
          "Sales professionals and dealerships dedicated to rotorcraft — new, used, or mission-equipped.",
      },
      {
        type: "piston_aircraft_brokers_dealers",
        label: "Piston Aircraft Brokers & Dealers",
        icon: "fa fa-plane-up",
        description:
          "Experts in the buying, selling, or trading of single- and twin-engine piston aircraft.",
      },
      {
        type: "private_jet_brokers_dealers",
        label: "Private Jet Brokers & Dealers",
        icon: "fa fa-plane-departure",
        description:
          "Boutique brokers focused on light and ultra-light private jet transactions and acquisitions.",
      },
    ],
  },
  {
    category: "Aircraft Charter Companies",
    subcategories: [
      {
        type: "on_demand_air_taxi_flights",
        label: "Air Taxi & On-Demand Flights",
        icon: "fa fa-taxi",
        description:
          "Flexible point-to-point air service for short hops and regional travel.",
      },
      {
        type: "aircraft_charter_companies",
        label: "Aircraft Charter Companies",
        icon: "fa fa-plane-circle-check",
        description:
          "On-demand air travel providers for private, corporate, or cargo flights.",
      },
      {
        type: "air_ambulance_services",
        label: "Air Ambulance Services",
        icon: "fa fa-truck-medical",
        description:
          "Aircraft equipped and staffed for emergency medical transport, medevac, and critical care in flight.",
      },
      {
        type: "aircraft_cargo_companies",
        label: "Aircraft Cargo Companies",
        icon: "fa fa-box-open",
        description:
          "Operators specializing in air freight, parcel logistics, and time-sensitive cargo delivery.",
      },
      {
        type: "aircraft_charter_brokers",
        label: "Aircraft Charter Brokers",
        icon: "fa fa-handshake",
        description:
          "Agencies that source aircraft and coordinate private or group charters through third-party operators.",
      },
      {
        type: "fractional_aircraft_ownership",
        label: "Fractional Aircraft Ownership",
        icon: "fa fa-share-nodes",
        description:
          "Programs offering shared ownership or guaranteed hours on private aircraft with lower upfront cost.",
      },
      {
        type: "international_aircraft_charter",
        label: "International Aircraft Charter",
        icon: "fa fa-earth-americas",
        description:
          "Providers specializing in cross-border or intercontinental private flight planning and execution.",
      },
      {
        type: "private_aircraft_charter_companies",
        label: "Private Aircraft Charter Companies",
        icon: "fa fa-plane-lock",
        description:
          "Charter operators focused exclusively on luxury or business-class private aircraft for individuals and small groups.",
      },
    ],
  },
  {
    category: "Aircraft Financing",
    subcategories: [
      {
        type: "appraisal_services",
        label: "Appraisal Services",
        icon: "fa fa-magnifying-glass-dollar",
        description:
          "Certified professionals who assess aircraft market value for financing, resale, or insurance purposes.",
      },
      {
        type: "aviation_banking_lending",
        label: "Aviation Banking & Lending",
        icon: "fa fa-money-bill-transfer",
        description:
          "Companies that offer aircraft loans, leases, and fractional financing options.",
      },
      {
        type: "escrow_services",
        label: "Escrow Services",
        icon: "fa fa-file-invoice-dollar",
        description:
          "Secure third-party services that manage funds, documents, and titles during aircraft transactions to protect both buyer and seller.",
      },
    ],
  },
  {
    category: "Aircraft Maintenance & Inspection",
    subcategories: [
      {
        type: "aog_aircraft_on_ground_support",
        label: "AOG (Aircraft on Ground) Support",
        icon: "fa fa-wrench",
        description:
          "Emergency repair teams ready to get you flying again, fast.",
      },
      {
        type: "airframe",
        label: "Airframe",
        icon: "fa fa-screwdriver-wrench",
        description:
          "Structural inspections, repairs, and modifications to fuselage, wings, and landing gear.",
      },
      {
        type: "commercial",
        label: "Commercial",
        icon: "fa fa-industry",
        description:
          "Maintenance services tailored to commercial aircraft operations and airline requirements.",
      },
      {
        type: "corporate",
        label: "Corporate",
        icon: "fa fa-briefcase",
        description:
          "Specialized upkeep for business jets, ensuring minimal downtime and high reliability.",
      },
      {
        type: "detailing_cleaning",
        label: "Detailing & Cleaning",
        icon: "fa fa-spray-can",
        description:
          "Professional interior and exterior cleaning, polishing, brightwork, and sanitation.",
      },
      {
        type: "engine_overhaul_repair",
        label: "Engine Overhaul & Repair",
        icon: "fa fa-gears",
        description:
          "Full teardown, inspection, and rebuild services for piston and turbine engines to manufacturer specs.",
      },
      {
        type: "equipment",
        label: "Equipment",
        icon: "fa fa-cogs",
        description:
          "Maintenance and calibration of onboard aircraft systems, tools, and specialty equipment.",
      },
      {
        type: "helicopters",
        label: "Helicopters",
        icon: "fa fa-helicopter",
        description:
          "Rotary-wing aircraft maintenance, including rotor systems, gearboxes, and avionics.",
      },
      {
        type: "jet_aircraft",
        label: "Jet Aircraft",
        icon: "fa fa-jet-fighter",
        description:
          "Scheduled and unscheduled maintenance for light, midsize, and heavy jets.",
      },
      {
        type: "light_sport_aircraft",
        label: "Light Sport Aircraft",
        icon: "fa fa-plane-up",
        description:
          "Services for LSA-class aircraft, including Rotax engine support and composite repairs.",
      },
      {
        type: "maintenance_programs",
        label: "Maintenance Programs",
        icon: "fa fa-clipboard-list",
        description:
          "Flat-rate or subscription-based service plans covering regular maintenance, inspections, and compliance.",
      },
      {
        type: "maintenance_repair_and_overhaul",
        label: "Maintenance, Repair and Overhaul",
        icon: "fa fa-screwdriver-wrench",
        description:
          "Routine and unscheduled inspections, repairs, part replacements, overhaul work, and airworthiness compliance.",
      },
      {
        type: "pre_purchase_inspections",
        label: "Pre-Purchase Inspections",
        icon: "fa fa-file-contract",
        description:
          "Thorough aircraft pre-buy inspections to verify condition, logbook accuracy, and airworthiness and ensure safety, compliance, and value.",
      },
      {
        type: "piston_aircraft",
        label: "Piston Aircraft",
        icon: "fa fa-engine",
        description:
          "Maintenance focused on single and twin-engine piston aircraft used in GA and training.",
      },
      {
        type: "tools",
        label: "Tools",
        icon: "fa fa-toolbox",
        description:
          "Specialized tooling, calibration services, and sales for aircraft maintenance operations.",
      },
    ],
  },
  {
    category: "Aircraft Manufacturers",
    subcategories: [
      {
        type: "aircraft_manufacturers",
        label: "Aircraft Manufacturers",
        icon: "fa fa-industry",
        description:
          "Full-service OEMs producing certified aircraft for personal, commercial, or government use.",
      },
      {
        type: "commercial_manufacturers",
        label: "Commercial",
        icon: "fa fa-building",
        description:
          "Manufacturers of passenger and cargo aircraft for airlines and fleet operators.",
      },
      {
        type: "corporate_manufacturers",
        label: "Corporate",
        icon: "fa fa-city",
        description:
          "Builders of business-class aircraft tailored to executive and VIP travel.",
      },
      {
        type: "engines",
        label: "Engines",
        icon: "fa fa-fan",
        description:
          "Companies specializing in the design and manufacturing of aircraft engines (piston, turbine, jet).",
      },
      {
        type: "helicopter",
        label: "Helicopter",
        icon: "fa fa-helicopter",
        description:
          "OEMs producing rotary-wing aircraft for civilian, military, or utility applications.",
      },
      {
        type: "jet_aircraft",
        label: "Jet Aircraft",
        icon: "fa fa-jet-fighter-up",
        description:
          "Manufacturers of light, midsize, and heavy jets for private, commercial, or specialized use.",
      },
      {
        type: "light_sport_aircraft",
        label: "Light Sport Aircraft",
        icon: "fa fa-plane-up",
        description:
          "Builders of lightweight, recreational aircraft under LSA certification standards.",
      },
      {
        type: "military",
        label: "Military",
        icon: "fa fa-shield-halved",
        description:
          "Defense contractors and OEMs producing aircraft for military operations and national defense.",
      },
      {
        type: "piston_aircraft",
        label: "Piston Aircraft",
        icon: "fa fa-engine",
        description:
          "Manufacturers of general aviation aircraft powered by piston engines — ideal for training and personal use.",
      },
    ],
  },
  {
    category: "Aircraft Upgrades & Customization",
    subcategories: [
      {
        type: "avionics_upgrades",
        label: "Avionics Upgrades",
        icon: "fa fa-microchip",
        description:
          "Installation of advanced navigation, communication, and flight management systems.",
      },
      {
        type: "cabin_entertainment_connectivity",
        label: "Cabin Entertainment & Connectivity",
        icon: "fa fa-wifi",
        description:
          "In-flight Wi-Fi, audio/video systems, and passenger control technology installations.",
      },
      {
        type: "completion_refurbishment_centers",
        label: "Completion & Refurbishment Centers",
        icon: "fa fa-paint-roller",
        description:
          "Full-service providers for interior outfitting, luxury cabin upgrades, and final delivery customizations — especially for new or “green” aircraft.",
      },
      {
        type: "paint_interior",
        label: "Paint & Interior",
        icon: "fa fa-brush",
        description:
          "Full exterior paint jobs, custom designs, and touch-ups. Seats, cabinetry, lighting, and upholstery upgrades or repairs.",
      },
      {
        type: "stc_modifications",
        label: "STC Modifications",
        icon: "fa fa-certificate",
        description:
          "FAA-approved structural or performance upgrades under Supplemental Type Certificates.",
      },
    ],
  },
  {
    category: "Aircraft Parts & Component Suppliers",
    subcategories: [
      {
        type: "airplane_parts_manufacturers",
        label: "Airplane Parts Manufacturers",
        icon: "fa fa-gears",
        description:
          "Authorized DistributorsLicensed resellers of parts from major OEMs and aviation brands.",
      },
      {
        type: "fuel_cell_tank_specialists",
        label: "Fuel Cell & Tank Specialits",
        icon: "fa fa-gas-pump",
        description:
          "Vendors and technicians focused on aircraft fuel systems and cell replacements.",
      },
      {
        type: "oem_aftermarket_parts_suppliers",
        label: "OEM & Aftermarket Parts Suppliers",
        icon: "fa fa-warehouse",
        description:
          "Manufacturers and vendors offering new, certified original or third-party parts.",
      },
      {
        type: "overhauler_exchange_services",
        label: "Overhauler & Exchange Services",
        icon: "fa fa-sync-alt",
        description:
          "Providers who refurbish, certify, and offer replacement parts on an exchange basis.",
      },
      {
        type: "parts_locators",
        label: "Parts Locators",
        icon: "fa fa-search",
        description:
          "Specialists in sourcing hard-to-find, discontinued, or legacy aircraft components.",
      },
      {
        type: "salvage",
        label: "Salvage",
        icon: "fa fa-recycle",
        description:
          "Recycled parts and airworthy components pulled from decommissioned aircraft.",
      },
    ],
  },
  {
    category: "Airport FBOs & Ground Services",
    subcategories: [
      {
        type: "fbos",
        label: "FBOs",
        icon: "fa fa-building-columns",
        description:
          "Full-service aviation hubs offering fuel, crew lounges, concierge, hangar space, ground handling, and more.",
      },
      {
        type: "fuel_cards",
        label: "Fuel Cards",
        icon: "fa fa-credit-card",
        description:
          "Membership or discount programs for pilots and operators to access fuel at preferred rates across partner FBOs.",
      },
      {
        type: "fueling_services_jet_a_avg",
        label: "Fueling Services (Jet A, Avgas)",
        icon: "fa fa-gas-pump",
        description:
          "On-site fueling providers for both turbine and piston aircraft, including self-serve and full-serve options.",
      },
      {
        type: "ground_handlers",
        label: "Ground Handlers",
        icon: "fa fa-people-carry-box",
        description:
          "Staff and companies providing aircraft marshaling, baggage handling, towing, lav service, and GPU hookups.",
      },
      {
        type: "international",
        label: "International",
        icon: "fa fa-globe",
        description:
          "FBOs and service providers specializing in customs clearance, international handling, and cross-border flight support.",
      },
    ],
  },
  {
    category: "Airports, Airfields & Heliports",
    subcategories: [
      {
        type: "airports_usa",
        label: "Airports - USA",
        icon: "fa fa-flag-usa",
        description:
          "Public and private-use airports located across the United States, including GA fields and towered facilities.",
      },
      {
        type: "airports_international",
        label: "Airports - International",
        icon: "fa fa-earth-europe",
        description:
          "Airports outside the U.S., serving general aviation, commercial, and cargo operations worldwide.",
      },
      {
        type: "airport_consulting",
        label: "Airport Consulting",
        icon: "fa fa-handshake-angle",
        description:
          "Professionals who offer planning, design, operations, and compliance services for airport development and management.",
      },
      {
        type: "ground_equipment",
        label: "Ground Equipment",
        icon: "fa fa-truck-ramp-box",
        description:
          "Suppliers of airport support gear such as tugs, GPUs, fuel trucks, de-icing units, and safety equipment.",
      },
      {
        type: "ground_transportation_providers",
        label: "Ground Transportation Providers",
        icon: "fa fa-car",
        description:
          "Car rentals, shuttles, crew cars, and pre-arranged transport for pilots and passengers.",
      },
      {
        type: "hangar_rentals",
        label: "Hangar Rentals",
        icon: "fa fa-warehouse",
        description:
          "Short- and long-term storage options for aircraft of all sizes.",
      },
      {
        type: "tie_down_ramp_services",
        label: "Tie-Down & Ramp Services",
        icon: "fa fa-anchor",
        description:
          "Outdoor parking, aircraft securing, and ramp-side support.",
      },
    ],
  },
  {
    category: "Aviation Publications",
    subcategories: [
      {
        type: "aviation_media_companies",
        label: "Aviation Media Companies",
        icon: "fa fa-film",
        description:
          "Full-service publishers and media networks producing aviation content across digital, print, and video platforms.",
      },
      {
        type: "blogs",
        label: "Blogs",
        icon: "fa fa-blog",
        description:
          "Independent writers and industry professionals sharing personal experiences, insights, and aviation know-how.",
      },
      {
        type: "books",
        label: "Books",
        icon: "fa fa-book",
        description:
          "Published works covering aviation history, flight training, technical manuals, biographies, and more.",
      },
      {
        type: "creators_influencers",
        label: "Creators & Influencers",
        icon: "fa fa-users",
        description:
          "Aviation-focused content creators on YouTube, Instagram, TikTok, and beyond — inspiring the next generation of pilots and enthusiasts.",
      },
      {
        type: "magazines",
        label: "Magazines",
        icon: "fa fa-newspaper",
        description:
          "Print and digital periodicals featuring aircraft reviews, flight tips, industry trends, and pilot lifestyle.",
      },
      {
        type: "news",
        label: "News",
        icon: "fa fa-globe",
        description:
          "Real-time aviation news sources covering regulations, airspace changes, accidents, and aviation developments.",
      },
      {
        type: "social_networks",
        label: "Social Networks",
        icon: "fa fa-share-alt",
        description:
          "Online communities and platforms where aviators connect, share content, and discuss all things aviation.",
      },
    ],
  },
  {
    category: "Aviation Education & Training",
    subcategories: [
      {
        type: "aircraft_dispatcher_schools",
        label: "Aircraft Dispatcher Schools",
        icon: "fa fa-user-tie",
        description:
          "FAA-approved programs that train and certify dispatchers to plan and monitor flight operations.",
      },
      {
        type: "aircraft_maintenance_training",
        label: "Aircraft Maintenance Training",
        icon: "fa fa-tools",
        description:
          "Schools and programs focused on preparing students for A&P certification and aircraft systems maintenance careers.",
      },
      {
        type: "aviation_colleges_universities",
        label: "Aviation Colleges & Universities",
        icon: "fa fa-graduation-cap",
        description:
          "Accredited institutions offering degree programs in flight, maintenance, aerospace engineering, and aviation business.",
      },
      {
        type: "aviation_scholarships",
        label: "Aviation Scholarships",
        icon: "fa fa-dollar-sign",
        description:
          "Financial aid opportunities for students pursuing aviation careers in flight, maintenance, or operations.",
      },
      {
        type: "certified_flight_instructors",
        label: "Certified Flight Instructors",
        icon: "fa fa-chalkboard-teacher",
        description:
          "Advertise your expertise and connect with students seeking personalized flight instruction. Licensed instructors offering one-on-one or structured flight training for all pilot certificate levels.",
      },
      {
        type: "flying_clubs",
        label: "Flying Clubs",
        icon: "fa fa-users-rays",
        description:
          "Reach out to individuals with a dream to fly and showcase your training programs to future pilots. Member-based organizations providing affordable access to aircraft, instruction, and a supportive flying community.",
      },
      {
        type: "flight_schools_recurrent_aircraft_training",
        label: "Flight Schools & Recurrent Aircraft Training",
        icon: "fa fa-plane-departure",
        description:
          "Certified flight schools and instructors for private, instrument, commercial, multi-engine ratings, and more.",
      },
      {
        type: "flight_simulator_training",
        label: "Flight Simulator Training",
        icon: "fa fa-gamepad",
        description:
          "Hands-on training using full-motion or desktop simulators for safer, cost-effective learning and proficiency.",
      },
      {
        type: "ground_schools",
        label: "Ground Schools",
        icon: "fa fa-school",
        description:
          "Classroom or online programs covering the theoretical knowledge required for FAA written exams.",
      },
      {
        type: "helicopter_training",
        label: "Helicopter Training",
        icon: "fa fa-helicopter",
        description:
          "Specialized instruction for rotary-wing aircraft, from private to commercial pilot certifications.",
      },
      {
        type: "training_materials",
        label: "Training Materials",
        icon: "fa fa-book-reader",
        description:
          "Educational content such as textbooks, online courses, and exam prep tools for pilots and mechanics.",
      },
      {
        type: "drone_training_courses",
        label: "Drone Training Courses",
        icon: "fa fa-drone",
        description:
          "Connect with aspiring drone pilots seeking qualified instruction to launch their careers. Structured programs for aspiring drone pilots covering FAA Part 107 certification, flight safety, and career preparation.",
      },
    ],
  },
  {
    category: "Avionics",
    subcategories: [
      {
        type: "avionics",
        label: "Avionics",
        icon: "fa fa-satellite-dish",
        description:
          "General category for all avionics services, including sales, installation, and upgrades.",
      },
      {
        type: "avionics_resources",
        label: "Avionics Resources",
        icon: "fa fa-book",
        description:
          "Educational, technical, and regulatory resources related to avionics systems and maintenance.",
      },
      {
        type: "distributors",
        label: "Distributors",
        icon: "fa fa-truck",
        description:
          "Authorized resellers of avionics equipment from major manufacturers, including GPS, ADS-B, and communication systems.",
      },
      {
        type: "manufacturers",
        label: "Manufacturers",
        icon: "fa fa-industry",
        description:
          "Companies that design and produce avionics systems for navigation, communication, autopilot, and flight displays.",
      },
      {
        type: "repair",
        label: "Repair",
        icon: "fa fa-wrench",
        description:
          "Diagnostics, testing, and repair services for flight instruments, radios, and other electronic components.",
      },
      {
        type: "satellite_communications_systems",
        label: "Satellite Communications Systems",
        icon: "fa fa-satellite",
        description:
          "Providers and installers of SATCOM systems for in-flight internet, voice, weather, and global connectivity.",
      },
    ],
  },
  {
    category: "Entertainment & Experiences",
    subcategories: [
      {
        type: "adventures",
        label: "Adventures",
        icon: "fa fa-mountain",
        description:
          "Unique aviation-related activities such as formation flying, bush flying, aerobatics, skydiving, and backcountry excursions.",
      },
      {
        type: "airshows_fly_ins",
        label: "Airshows & Fly-Ins",
        icon: "fa fa-flag-checkered",
        description:
          "Events that celebrate aviation culture — from grassroots fly-ins to international showcases featuring aerial performances and static displays.",
      },
      {
        type: "aviation_museums",
        label: "Aviation Museums",
        icon: "fa fa-building-columns",
        description:
          "Institutions preserving and showcasing aviation history, aircraft, innovation, and educational exhibits.",
      },
      {
        type: "flight_flying_experiences",
        label: "Flight & Flying Experiences",
        icon: "fa fa-plane-up",
        description:
          "Hands-on discovery flights, introductory lessons, and thrill rides for aspiring pilots and aviation enthusiasts.",
      },
      {
        type: "sightseeing_scenic_tours",
        label: "Sightseeing & Scenic Tours",
        icon: "fa fa-binoculars",
        description:
          "Aerial experiences and scenic flights over iconic destinations, landmarks, and natural wonders.",
      },
    ],
  },
  {
    category: "Insurance Companies",
    subcategories: [
      {
        type: "aviation_related_insurance_companies",
        label: "Aviation-Related Insurance Companies",
        icon: "fa fa-hand-holding-dollar",
        description:
          "Firms that specialize in underwriting aircraft, airport, hangar, and aviation business policies.",
      },
      {
        type: "aircraft_insurance_coverage",
        label: "Aircraft Insurance Coverage",
        icon: "fa fa-car-crash",
        description:
          "Policies covering hull damage, liability, in-flight incidents, ground risk, and comprehensive protection for aircraft owners.",
      },
      {
        type: "pilot_insurance",
        label: "Pilot Insurance",
        icon: "fa fa-user-shield",
        description:
          "Coverage tailored to individual pilots, including life, loss of license, medical, and liability protection.",
      },
    ],
  },
  {
    category: "Lodging & Hospitality",
    subcategories: [
      {
        type: "fly_in_friendly_lodging",
        label: "Fly-In Friendly Lodging",
        icon: "fa fa-bed",
        description:
          "Hotels, cabins, and inns located near airparks, runways, or private strips — with easy aircraft access.",
      },
      {
        type: "pilot_lodging_packages",
        label: "Pilot Lodging Packages",
        icon: "fa fa-hotel",
        description:
          "Accommodations offering exclusive discounts, transportation, or perks for aviators.",
      },
      {
        type: "airport_restaurants_cafes",
        label: "Airport Restaurants & Cafes",
        icon: "fa fa-utensils",
        description:
          "Dining spots located on or near airfields — perfect for $100 hamburgers and crew meals.",
      },
      {
        type: "aviation_themed_destinations",
        label: "Aviation-Themed Destinations",
        icon: "fa fa-map-marker-alt",
        description:
          "Unique overnight spots and resorts designed for aviation lovers and adventure seekers.",
      },
    ],
  },
  {
    category: "Media Services",
    subcategories: [
      {
        type: "aviation_photographers",
        label: "Aviation Photographers",
        icon: "fa fa-camera",
        description:
          "Specialists in capturing high-resolution stills of aircraft in flight, on the ramp, at events, or for promotional use.",
      },
      {
        type: "aviation_videographers",
        label: "Aviation Videographers",
        icon: "fa fa-video",
        description:
          "Professionals producing cinematic, documentary, or commercial video content for aviation brands, events, or aircraft sales.",
      },
      {
        type: "drone_pilots",
        label: "Drone Pilots",
        icon: "fa fa-drone",
        description:
          "Certified UAV operators offering aerial imagery, inspections, and creative footage for aviation marketing or operational needs.",
      },
    ],
  },
  {
    category: "Other Services",
    subcategories: [
      {
        type: "accounting_tax_services",
        label: "Accounting / Tax Services",
        icon: "fa fa-calculator",
        description:
          "Specialists in aircraft depreciation, tax strategies, cost recovery, and business use optimization.",
      },
      {
        type: "agricultural_utility_flying",
        label: "Agricultural / Utility Flying",
        icon: "fa fa-leaf",
        description:
          "Crop-dusting, pipeline patrol, aerial photography, firefighting, aerial survey, wildlife management, and other specialized ops.",
      },
      {
        type: "air_display_companies",
        label: "Air Show Performers",
        icon: "fa fa-plane-alt",
        description:
          "Teams and pilots offering aerobatic displays and formation flying for airshows and special events.",
      },
      {
        type: "air_shows_trade_shows",
        label: "Air Shows & Trade Shows",
        icon: "fa fa-exclamation",
        description:
          "Organizations and companies that organize or participate in aviation expos, exhibitions, and fly-ins.",
      },
      {
        type: "aircraft_hangar_construction_companies",
        label: "Aircraft Hangar Construction Companies",
        icon: "fa fa-hard-hat",
        description:
          "Builders specializing in custom aircraft hangars, T-hangars, and aviation facility infrastructure.",
      },
      {
        type: "aircraft_management_companies",
        label: "Aircraft Management Companies",
        icon: "fa fa-tasks",
        description:
          "Turnkey services handling everything from maintenance and compliance to staffing and scheduling for aircraft owners.",
      },
      {
        type: "aircraft_valeting_companies",
        label: "Aircraft Valeting Companies",
        icon: "fa fa-car-wash",
        description:
          "Providers of premium aircraft interior and exterior cleaning, detailing, and presentation services.",
      },
      {
        type: "aviation_consultants",
        label: "Aviation Consultants",
        icon: "fa fa-user-tie",
        description:
          "Experts offering advisory services in regulatory compliance, operational efficiency, airport planning, and aircraft acquisition.",
      },
      {
        type: "aviation_law_firms",
        label: "Aviation Law Firms",
        icon: "fa fa-gavel",
        description:
          "Legal professionals focused on aircraft transactions, FAA enforcement, aviation litigation, and regulatory law.",
      },
      {
        type: "aviation_marketing_companies",
        label: "Aviation Marketing Companies",
        icon: "fa fa-bullhorn",
        description:
          "Agencies specializing in branding, content, digital ads, and social media for aviation businesses.",
      },
      {
        type: "charities_aviation_charities",
        label: "Charities Aviation Charities",
        icon: "fa fa-hand-holding-heart",
        description:
          "Nonprofits that provide flights for humanitarian causes, veteran support, youth aviation programs, and disaster response.",
      },
      {
        type: "cleaning_solutions_polishes",
        label: "Cleaning Solutions-Polishes",
        icon: "fa fa-soap",
        description:
          "Manufacturers and suppliers of aviation-grade cleaning products for aircraft exteriors, interiors, and brightwork.",
      },
      {
        type: "collectibles",
        label: "Collectibles",
        icon: "fa fa-box",
        description:
          "Aviation-themed merchandise including model aircraft, patches, vintage instruments, art, and memorabilia.",
      },
      {
        type: "ferry_service_aircraft_ferrying_companies",
        label: "Ferry Service Aircraft Ferrying Companies",
        icon: "fa fa-plane-slash",
        description:
          "Professional pilots and services that relocate aircraft across states or internationally for delivery or repositioning.",
      },
      {
        type: "flight_simulator_experience_companies",
        label: "Flight Simulator Experience Companies",
        icon: "fa fa-gamepad",
        description:
          "Businesses offering immersive flight sim experiences to the public or for pilot training enhancement.",
      },
      {
        type: "flight_support",
        label: "Flight Support",
        icon: "fa fa-life-ring",
        description:
          "Concierge services assisting with permits, ground handling, fuel, and international ops planning.",
      },
      {
        type: "freelance_pilots",
        label: "Freelance Pilots",
        icon: "fa fa-user-pilot",
        description:
          "Independent, contract-based pilots available for ferry flights, instruction, part-time operations, or crew augmentation.",
      },
      {
        type: "gliding_clubs",
        label: "Gliding Clubs",
        icon: "fa fa-wind",
        description:
          "Member-based organizations focused on non-powered flight and sailplane training, events, and recreation.",
      },
      {
        type: "hangars_for_sale_lease_hangarage",
        label: "Hangars for Sale/Lease Hangarage",
        icon: "fa fa-warehouse",
        description:
          "Listings and brokers for buying, selling, or leasing aircraft hangars across airports and private strips.",
      },
      {
        type: "inflight_catering",
        label: "InFlight Catering",
        icon: "fa fa-bread-slice",
        description:
          "Providers of high-quality meals, snacks, and beverages tailored for corporate and private jet flights.",
      },
      {
        type: "legal_compliance_consultants",
        label: "Legal & Compliance Consultants",
        icon: "fa fa-balance-scale",
        description:
          "Experts in FAA/ICAO regulations, aircraft registration, import/export, and ownership structures.",
      },
      {
        type: "limousine_transportation_services",
        label: "Limousine Transportation Services",
        icon: "fa fa-car-side",
        description:
          "Luxury ground transport providers offering pickup/drop-off to airports, FBOs, and aviation events.",
      },
      {
        type: "other_services",
        label: "Other Services",
        icon: "fa fa-ellipsis-h",
        description:
          "A general-purpose category for Aviation-related businesses that offer value to pilots, owners, or operators.",
      },
      {
        type: "oxygen_systems",
        label: "Oxygen Systems",
        icon: "fa fa-lungs",
        description:
          "Suppliers and technicians specializing in aviation oxygen tanks, masks, servicing, and delivery systems.",
      },
      {
        type: "pilot_merchandise_gifts",
        label: "Pilot Merchandise & Gifts",
        icon: "fa fa-gift",
        description:
          "Apparel, gear, décor, and curated gifts for pilots and aviation lovers.",
      },
      {
        type: "real_estate_agents",
        label: "Real Estate Agents",
        icon: "fa fa-house-chimney",
        description:
          "Aviation properties including airpark homes, hangar homes, and runway-access real estate listings.",
      },
      {
        type: "safety_quality_and_risk_management",
        label: "Safety Quality and Risk Management",
        icon: "fa fa-check-circle",
        description:
          "Services focused on SMS (Safety Management Systems), audits, incident prevention, and regulatory alignment.",
      },
      {
        type: "security",
        label: "Security",
        icon: "fa fa-lock",
        description:
          "Providers of airport and aircraft security systems, access control, surveillance, and threat mitigation.",
      },
      {
        type: "skydiving",
        label: "Skydiving",
        icon: "fa fa-parachute-box",
        description:
          "Skydiving centers, instructors, and tandem operations offering thrilling jumps and aviation experiences.",
      },
    ],
  },
  {
    category: "Pilot Services",
    subcategories: [
      {
        type: "associations",
        label: "Associations",
        icon: "fa fa-users",
        description:
          "Professional pilot organizations offering advocacy, networking, certification support, and career development.",
      },
      {
        type: "employment",
        label: "Employment",
        icon: "fa fa-briefcase",
        description:
          "Job boards, recruiting services, and contract pilot agencies for full-time, part-time, or freelance flying opportunities.",
      },
      {
        type: "management_software",
        label: "Management Software",
        icon: "fa fa-laptop-code",
        description:
          "Digital tools to help pilots track flight hours, currencies, schedules, endorsements, and aircraft access.",
      },
      {
        type: "medical_services",
        label: "Medical Services",
        icon: "fa fa-user-md",
        description:
          "FAA-approved aviation medical examiners (AMEs) and services related to pilot health, certification, and renewals.",
      },
      {
        type: "pilot_operations_software",
        label: "Pilot Operations Software",
        icon: "fa fa-chart-line",
        description:
          "Flight planning, logbook, checklist, and documentation tools designed for daily pilot operations.",
      },
      {
        type: "pilot_resources",
        label: "Pilot Resources",
        icon: "fa fa-book-reader",
        description:
          "Online tools, guides, and communities supporting training, currency, aircraft systems knowledge, and continuing education.",
      },
      {
        type: "pilot_supplies",
        label: "Pilot Supplies",
        icon: "fa fa-shopping-bag",
        description:
          "Flight bags, headsets, charts, kneeboards, and other cockpit essentials for student and professional pilots.",
      },
    ],
  },
  {
    category: "Technology & Software",
    subcategories: [
      {
        type: "aircraft_scheduling_software",
        label: "Aircraft Scheduling Software",
        icon: "fa fa-calendar-alt",
        description:
          "Tools for managing aircraft availability, booking, and crew assignments.",
      },
      {
        type: "airport_management_systems",
        label: "Airport Management Systems",
        icon: "fa fa-desktop",
        description:
          "Solutions for FBOs, airparks, and airports to manage services, billing, and operations.",
      },
      {
        type: "flight_planning_tools",
        label: "Flight Planning Tools",
        icon: "fa fa-map",
        description:
          "Apps and software for weather routing, fuel calculations, NOTAMs, and preflight prep.",
      },
      {
        type: "logbook_maintenance_tracking",
        label: "Logbook & Maintenance Tracking",
        icon: "fa fa-clipboard",
        description:
          "Digital platforms and services to manage logbooks, track inspections, airworthiness directives, hours, and service records.",
      },
      {
        type: "tech_support",
        label: "Tech. Support",
        icon: "fa fa-headset",
        description:
          "IT services and support providers specializing in aviation systems, software implementation, troubleshooting, and ongoing tech infrastructure needs.",
      },
    ],
  },
];

export const DEFAULT_TYPE_ICONS = {
  restaurants: "fa-utensils", // FontAwesome class
  events: "fa-calendar-alt",
  shopping: "fa-shopping-bag",
  adventures: "fa-hiking",
  hotels: "fa-hotel",
  flight_schools: "fa-plane-departure",
  cfis: "fa-plane",
  aircraft_sales_rentals: "fa-plane",
  aircraft_services_parts: "fa-cogs",
  medical_examiners: "fa-user-md",
  insurance: "fa-shield-alt",
  aircraft_sales_new: "fa-plane",
  aircraft_sales_pre_owned: "fa-plane",
  leasing_fractional_ownership: "fa-plane",
  commercial_aircraft_brokers_dealers: "fa-plane",
  corporate_jet_brokers_dealers: "fa-plane",
  helicopter_brokers_dealers: "fa-helicopter",
  piston_aircraft_brokers_dealers: "fa-plane-up",
  private_jet_brokers_dealers: "fa-plane-departure",
  stays: "fa-home", // Add for the 'stays' type
  default: "fa-building", // A general fallback icon
};
export * from "./fake_conversation";
